import { render, staticRenderFns } from "./Shussou.vue?vue&type=template&id=4023e3b4&scoped=true"
import script from "./Shussou.vue?vue&type=script&lang=js"
export * from "./Shussou.vue?vue&type=script&lang=js"
import style0 from "./Shussou.vue?vue&type=style&index=0&id=4023e3b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4023e3b4",
  null
  
)

export default component.exports